import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import axios from 'axios';
import {URL} from '../../Apis/Constants';
import {errorMsg} from '../../Apis/functions';
import { DEPARTMENT_SERVICE, DOCUMENT_SERVICE, EMPLOYEE_SERVICE, EXTRA_DATA_SERVICE, FIREARM_SERVICE, IMAGE_SERVICE, ROLE_SERVICE, STATUS_SERVICE, USER_SERVICE, VEHICLE_COMPANY_SERVICE, WORK_SHIFT_SERVICE, ZONE_SERVICE } from '../EndPoints';

const config = {
    headers: {
        'content-type': 'multipart/form-data',
    },
};



export const getSingleEmployeeDetail = createAsyncThunk('companyEmployees/getSingleEmployeeDetail', async (id) => {
    const result = await apiInstance
        .get(`${EMPLOYEE_SERVICE.getSingleEmployeeDetail}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const getSingleEmployeeWithId = createAsyncThunk('companyEmployees/getSingleEmployeeWithId', async (id) => {
    const result = await apiInstance
        .get(`${EMPLOYEE_SERVICE.getSingleEmployeeWithId}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const getRoles = createAsyncThunk('companyEmployees/getRoles', async () => {
    const result = await apiInstance
        .get(ROLE_SERVICE.getRoles)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const getWorkStations = createAsyncThunk('companyEmployees/getWorkStations', async () => {
    const result = await apiInstance
        .get(ZONE_SERVICE.getWorkStations)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const getDepartments = createAsyncThunk('companyEmployees/getDepartments', async () => {
    const result = await apiInstance
        .get(DEPARTMENT_SERVICE.getDepartments)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// @GetWorkShiftAccess
// export const GetWorkShiftAccess = createAsyncThunk(
//   "companyEmployees/getWorkStations",
//   async (params) => {
//     let result = await apiInstance
//       .post(`work-shift-service/work/get-all-pageable/by-user-id/${""}`, params.pagination)
//       .then(function (response) {
//         return response;
//       })
//       .catch(function (error) {
//         return error.response;
//       });
//     const { data, status } = result;

//     return { data, status };
//   }
// );
export const addWorkShift = createAsyncThunk('companyEmployees/addWorkShift', async (body) => {
    const result = await apiInstance
        .get(WORK_SHIFT_SERVICE.addWorkShift(body.workShiftId, body.userId))
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const addCustomWorkShift = createAsyncThunk('companyEmployees/addCustomWorkShift', async (body) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.addCustomWorkShift, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const qrCodeByEmail = createAsyncThunk('companyEmployees/qrCodeByEmail', async (id) => {
    const result = await apiInstance
        .get(`${USER_SERVICE.qrCodeByEmail}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const ResetByAttemps = createAsyncThunk('companyEmployees/resetByAttemps', async (id) => {
    const result = await apiInstance
        .put(`${USER_SERVICE.resetByAttemps}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const ResetUnlockedAccount = createAsyncThunk('companyEmployees/resetUnlockedAccount', async (id) => {
    const result = await apiInstance
        .put(`${USER_SERVICE.resetUnlockedAccount}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});


export const hasSelfi = createAsyncThunk('companyEmployees/hasSelfi', async (id) => {
    const result = await apiInstance
        .get(`${USER_SERVICE.hasSelfi}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
//se envia con la imagen
export const createImgObj = createAsyncThunk('companyEmployees/createImgObj', async (body) => {
    const result = await apiInstance
        .post(USER_SERVICE.createImgObj, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const PublicCreateUserImage = createAsyncThunk('companyEmployees/publicCreateUserImage', async (params, { dispatch, getState }) => {
        try {
            return await axios.post(`${URL}${USER_SERVICE.publicCreateUserImage}`, params);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const getSelfie = createAsyncThunk('companyEmployees/getSelfie', async (userId) => {
    const result = await apiInstance
        .get(`${USER_SERVICE.getSelfie}${userId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const updateUserEmployee = createAsyncThunk('companyEmployees/updateUserEmployee', async (body) => {
    const result = await apiInstance
        .put(EMPLOYEE_SERVICE.updateUserEmployee, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const updateExtraData = createAsyncThunk('companyEmployees/updateExtraData', async (body) => {
    const result = await apiInstance
        .put(`${EXTRA_DATA_SERVICE.updateExtraData}${body.id}`, body.obj)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const documentListing = createAsyncThunk('companyEmployees/documentListing', async (userId) => {
    const result = await apiInstance
        .get(`${DOCUMENT_SERVICE.documentListing}${userId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const employeeVehicles = createAsyncThunk('companyEmployees/employeeVehicles', async (userId) => {
    const result = await apiInstance
        .get(`${VEHICLE_COMPANY_SERVICE.employeeVehicles}${userId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const checkFireArms = createAsyncThunk('companyEmployees/checkFireArms', async (userId) => {
    const result = await apiInstance
        .get(`${FIREARM_SERVICE.checkFireArms}${userId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const userInfoStatus = createAsyncThunk('companyEmployees/userInfoStatus', async () => {
    const result = await apiInstance
        .get(STATUS_SERVICE.userInfoStatus)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const creatFireArms = createAsyncThunk('companyEmployees/creatFireArms', async (body) => {
    const result = await apiInstance
        .post(FIREARM_SERVICE.creatFireArms, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const updateFireArms = createAsyncThunk('companyEmployees/updateFireArms', async (body) => {
    const result = await apiInstance
        .put(FIREARM_SERVICE.updateFireArms, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const getFireArm = createAsyncThunk('companyEmployees/getFireArm', async (userId) => {
    const result = await apiInstance
        .get(`${FIREARM_SERVICE.getFireArm}${userId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const approveDocs = createAsyncThunk('companyEmployees/approveDocs', async (body) => {
    const result = await apiInstance
        .post(DOCUMENT_SERVICE.approveDocs, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAllUserByUserTypeId = createAsyncThunk('companyEmployees/getAllUserByUserTypeId', async (body) => {
    const result = await apiInstance
        .post(USER_SERVICE.getAllUserByUserTypeId, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const ValidateIdentity = createAsyncThunk('companyEmployees/validateIdentity', async (body) => {
    const result = await apiInstance
        .put(USER_SERVICE.validateIdentity, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const UpdateUserStatus = createAsyncThunk('companyEmployees/updateUserStatus', async (body) => {
    const result = await apiInstance
        .put(USER_SERVICE.updateUserStatus, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
